if (!customElements.get('before-after-slider')) {
    customElements.define(
        'before-after-slider',
        class BeforeAfterSlider extends HTMLElement {
            constructor() {
                super();

                this.button = this.querySelector('.before-after-slider__handle');
                this.isHorizontal = true;

                this.startDrag = this.onStartDrag.bind(this);
                this.drag = this.onDrag.bind(this);
                this.stopDrag = this.onStopDrag.bind(this);

                this.init();
            }

            init() {
                if (!this.button) return;
                this.buttonIcon = this.button.querySelector('.before-after-slider__handle-icon');
                // Default offset if icon is missing
                this.offset = this.buttonIcon ? this.buttonIcon.offsetWidth / 2 : 20;

                this.button.addEventListener('touchstart', this.startDrag, { passive: false });
                this.button.addEventListener('mousedown', this.startDrag);
            }

            onStartDrag(e) {
                if (e.cancelable) e.preventDefault();
                document.body.classList.add('body-no-scrollbar');
                this.classList.add('is-dragging');

                if (e.type === 'mousedown') {
                    document.addEventListener('mousemove', this.drag);
                    document.addEventListener('mouseup', this.stopDrag);
                } else if (e.type === 'touchstart') {
                    document.addEventListener('touchmove', this.drag, { passive: false });
                    document.addEventListener('touchend', this.stopDrag);
                }
            }

            onStopDrag() {
                document.body.classList.remove('body-no-scrollbar');
                this.classList.remove('is-dragging');

                document.removeEventListener('mousemove', this.drag);
                document.removeEventListener('mouseup', this.stopDrag);

                document.removeEventListener('touchmove', this.drag);
                document.removeEventListener('touchend', this.stopDrag);
            }

            onDrag(e) {
                const event = (e.touches && e.touches[0]) || e;

                // Use getBoundingClientRect for robust coordinate calculation relative to viewport
                const rect = this.getBoundingClientRect();
                const clientX = event.clientX;

                // Calculate x relative to the left edge of the element
                let x = clientX - rect.left;
                const distance = rect.width;

                // Ensure we don't go out of bounds
                // Allow a small buffer so the handle doesn't get stuck instantly at 0 or 100
                const min = 0;
                const max = distance;

                const mouseX = Math.max(min, Math.min(x, max));
                const mousePercent = (mouseX * 100) / distance;

                this.style.setProperty('--percent', mousePercent + '%');
            }
        }
    );
}
